import { SET_SELECTED_SERVICES } from '../constants/selectedServices';

export const setServicesSelected = value => dispatch =>
    dispatch({
        type: SET_SELECTED_SERVICES,
        payload: value
    });
